<template>
  <section id="contact-form" class="py-20 bg-gradient-to-t from-base-100 to-primary/5">
    <div class="container mx-auto px-4">
      <div class="max-w-2xl mx-auto">
        <h2 class="text-4xl font-semibold text-center text-primary mb-6">
          {{ $t("components.contactForm.title") }}
        </h2>
        <form @submit.prevent="submitForm" class="grid gap-4">
          <input
            v-model="form.name"
            type="text"
            :placeholder="$t('components.contactForm.namePlaceholder')"
            class="input input-bordered w-full shadow"
            required />
          <input
            v-model="form.email"
            type="email"
            :placeholder="$t('components.contactForm.emailPlaceholder')"
            class="input input-bordered w-full shadow"
            required />
          <select v-model="form.subject" class="select select-bordered w-full shadow">
            <option disabled value="">{{ $t("components.contactForm.subjectDefault") }}</option>
            <option>{{ $t("components.contactForm.subjectGeneral") }}</option>
            <option>{{ $t("components.contactForm.subjectSupport") }}</option>
            <option>{{ $t("components.contactForm.subjectCollaboration") }}</option>
          </select>
          <textarea
            v-model="form.message"
            :placeholder="$t('components.contactForm.messagePlaceholder')"
            class="textarea textarea-bordered w-full shadow"
            rows="5"
            required></textarea>
          <button type="submit" class="btn btn-primary w-full">
            {{ $t("components.contactForm.submit") }}
          </button>
        </form>
        <p v-if="success" class="text-success mt-4 text-center">
          {{ $t("components.contactForm.success") }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from "vue";

const form = ref({
  name: "",
  email: "",
  subject: "",
  message: "",
});
const success = ref(false);

async function submitForm() {
  const res = await fetch("/api/contact", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(form.value),
  });
  if (res.ok) {
    form.value = { name: "", email: "", subject: "", message: "" };
    success.value = true;
  }
}
</script>
